const ChartWrapper = ({ children }) => {
  return <div className="h-full hidden xl:flex xl:w-[20vw] items-center justify-center absolute left-full pl-[2.5vw] top-0">{children}</div>
}

export default ChartWrapper
